import React, { useState, useContext, useEffect } from "react";
import styles from "./styles/Instalment.module.css";
import DataContext from "../../../context/DataContext";
import {
    capitalizeFirstLetter,
    formatDateToLocalDate,
} from "../../../utils/utils";
import { calculateValues } from "../../../utils/utils";
import { ReactComponent as Mandetory } from "../../../assets/mandetory.svg";
import POSDataContext from "../../../context/POSDataContext";
import useNumberFormat from "../../../hooks/useNumberFormat";
import { ReactComponent as IconGavel } from "../../../assets/gavel.svg";
import { ReactComponent as IconBill } from "../../../assets/bill-1.svg";
import { ReactComponent as IconClock } from "../../../assets/clock.svg";
import { useTranslation } from "react-i18next";

/**
 * SideTicket component
 */
const Instalment = ({
    instalment,
    caseNo,
    currency,

    handleCheckFunction,
    selectedSettlements,

    setCurrenInstalment,
    clickedInstalment,
    handleClickedInstalment,

    transactionID,
}) => {
    const [isSelected, setIsSelected] = useState(false);
    const formatNum = useNumberFormat();
    const { t } = useTranslation();

    const { selectedInstalments, setIsInstallemtHover, connection } =
        useContext(DataContext);

    useEffect(() => {
        setIsSelected(isInSelectedInstalments());
    }, [selectedInstalments]);

    const onClickHandle = () => {
        setCurrenInstalment(instalment);

        handleClickedInstalment(instalment?.id);
    };

    const isInSelectedInstalments = () => {
        return (
            Array.isArray(selectedInstalments) &&
            selectedInstalments.some(
                (inst) =>
                    inst.instalmentId.toString() === instalment?.id.toString(),
            )
        );
    };
    const checkDisable = () => {
        return !selectedSettlements.includes(caseNo);
    };
    const getStatus = () => {
        switch (instalment?.status) {
            case 0:
                return "overdue";
            case 1:
                return "due";
            case 2:
                return "upcoming";
        }
    };
    const hoverfunction = (event) => {
        event.stopPropagation();
        if (event.type === "pointerenter") {
            setIsInstallemtHover(
                event.target.dataset.instinfo.match(/#(\d+)/)?.[1],
            );
        } else {
            setIsInstallemtHover("");
        }
    };

    return (
        <button
            className={`${styles.main_ticket_container} ${
                clickedInstalment === instalment?.id
                    ? instalment?.status === 0
                        ? styles.clicked_red
                        : instalment?.status === 1
                          ? styles.clicked_yellow
                          : styles.clicked
                    : ""
            } flex-container`}
            onClick={() => onClickHandle()}
        >
            <div className={`${styles.input_check_container} flex-container`}>
                {connection?.isPayment ? (
                    instalment?.status === 2 ? (
                        <>
                            {
                                <input
                                    onPointerEnter={(event) =>
                                        hoverfunction(event)
                                    }
                                    onPointerLeave={(event) =>
                                        hoverfunction(event)
                                    }
                                    data-instinfo={instalment?.txt}
                                    data-insttransactionid={transactionID}
                                    data-instalmentdate={
                                        instalment?.dateAndTime
                                    }
                                    className={`${styles.input_check_element} `}
                                    type="checkbox"
                                    name={instalment?.id}
                                    id={instalment?.id}
                                    value={instalment?.netAmount || 0}
                                    disabled={checkDisable()}
                                    onClick={handleCheckFunction}
                                    checked={!!isSelected}
                                    readOnly // Prevents React warnings since we're controlling `checked`
                                />
                            }
                            <label
                                className={`${styles.input_check_label}`}
                                htmlFor={instalment?.caseNo}
                                aria-label={`Check input for settlement ${instalment?.caseNo}`}
                            ></label>
                        </>
                    ) : (
                        <Mandetory
                            className={`${styles.mandetory_icon} ${
                                !checkDisable()
                                    ? styles.mandetory_icon_active
                                    : ""
                            }`}
                        />
                    )
                ) : (
                    <></>
                )}
            </div>

            <div className={`${styles.info_container} v-flex-container`}>
                <div className={`${styles.ticket_info} `}>
                    <span>
                        <IconClock
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {formatDateToLocalDate(instalment?.dateAndTime, true)}
                </div>
                <div
                    className={`${styles.ticket_info} ${styles.ticket_hide_info}`}
                    style={{
                        minWidth: "6rem",
                        textAlign: "left",
                    }}
                >
                    <span>
                        <IconGavel
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {capitalizeFirstLetter(t(getStatus()))}
                </div>
                <div
                    className={`${styles.ticket_info} 
                    
                    `}
                >
                    <span>
                        <IconBill
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {`${currency}${formatNum(instalment?.netAmount)}`}
                </div>
            </div>
        </button>
    );
};

export default Instalment;
